/*
 * Ryan O'Dowd
 * 2025-12-19
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import {
  Model,
  Q,
} from '@nozbe/watermelondb';
import {
  field,
  immutableRelation,
} from '@nozbe/watermelondb/decorators';
import {
  Associations,
} from '@nozbe/watermelondb/Model';
import utils from './utils';

export default class Footnote extends Model {
  static table = 'footnotes';
  static associations: Associations = {
    verse_texts: {type: 'belongs_to', key: 'verse_text_id'},
  };

  @field('footnote_id') footnoteId;
  @field('verse_text_id') verseTextId;
  @field('position_in_verse_text') positionInVerseText;
  @field('is_in_heading') isInHeading;
  @field('indicator') indicator;
  @field('body') body;

  @immutableRelation('verse_texts', 'verse_text_id') verseText;

  static async getAllByVerseTextIds(db, verseTextIds) {
    return db.get(this.table).query(
      Q.where('verse_text_id', Q.oneOf(verseTextIds)),
    ).fetch();
  }

  static async upsertAll(db, rows) {
    const collection = db.get(this.table);
    const existingRecords = await collection.query(Q.where('footnote_id', Q.oneOf(rows.map((row) => row.id)))).fetch();
    const existingRecordsByFootnoteId = Object.fromEntries(existingRecords.map((record) => [record.footnoteId, record]));
    await db.write(async () => {
      const updates = rows.map((row) => utils.prepareUpsertStatement(collection, existingRecordsByFootnoteId[row.id], ({footnote_id: row.id, ...row})));

      await db.batch(updates);
    });
  }

  static async deleteAllByVerseTextIds(db, verseTextsIds) {
    const collection = db.get(this.table);
    const existingRecords = await collection.query(Q.where('verse_text_id', Q.oneOf(verseTextsIds))).fetch();
    await db.write(async () => {
      await db.batch(existingRecords.map((footnote) => footnote.prepareDestroyPermanently()));
    });
  }
};
